<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">缺陷转出数</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 缺陷创建时间</p>
            <p>描述: 以缺陷创建人纬度计算缺陷处理人变动的数值累积和，没变动一次+1</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div id="task-point-rank" :style="{ height: height, width: width }" />
    </a-card>
    <issue-modal ref="issueModal" :issue-list="issueList" />
  </div>
</template>
<script>
import { queryIssueTurnOutNum } from '@/api/data/issue';
import IssueModal from '@/pages/data/quality/components/IssueModal';
export default {
  components: { IssueModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'team',
      loading: true,
      myChart: null,
      issueList: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      },
      data: [],
      detailFilterForm: {},
      detailVisible: false
    };
  },
  watch: {
    filterForm() {
      this.getTaskPointRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      const echarts = require('echarts/lib/echarts');
      require('echarts/lib/chart/bar'); // 柱状图
      // 下面的是需要的提示框
      require('echarts/lib/component/tooltip');
      require('echarts/lib/component/legend');
      require('echarts/lib/component/grid');
      require('echarts/lib/component/dataZoom');
      this.myChart = echarts.init(document.getElementById('task-point-rank'));
      this.myChart.setOption(this.option, true);
      const self = this;
      this.myChart.getZr().on('click', function (param) {
        const pointInPixel = [param.offsetX, param.offsetY];
        // 判断给定的点是否在指定的坐标系或者系列上
        if (self.myChart.containPixel('grid', pointInPixel)) {
          // 获取到点击的 x轴 下标  转换为逻辑坐标
          const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];

          self.onDetail(index);
        }
      });
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getTaskPointRank() {
      this.loading = true;
      queryIssueTurnOutNum({ ...this.filterForm })
        .then(res => {
          this.data = res.data[0];
          this.option.xAxis.data = this.data.xLineData;
          this.option.series = [
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '缺陷转出数据',
              data: this.data.YLineData
            }
          ];
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDetail(index) {
      this.detailVisible = true;
      this.issueList = this.data.yLineDetail[this.data.xLineData[index]];
      setTimeout(() => {
        this.$refs.issueModal.open();
      }, 10); // 延迟 200 毫秒
    },

    close() {
      this.detailVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
